import { apiGet, apiPut, apiPost, apiDelete } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getThirdPartyAccountsAPI = () => {
  return apiGet('mgmt/thirdparty')
}

export const deleteThirdPartyAccountAPI = (accountId) => {
  Hotjar.event('delete_third_party_account')
  return apiDelete(`mgmt/thirdparty/${accountId}`)
}

export const addThirdPartyAccountAPI = (account) => {
  Hotjar.event('add_third_party_account')
  return apiPost(`mgmt/thirdparty/`, account)
}

export const updateThirdPartyAccountAPI = (account) => {
  Hotjar.event('update_third_party_account')
  return apiPut(`mgmt/thirdparty/${account.id}`, account)
}

//BIOTRACK START

export const getBiotrackAccountApi = () => {
  return apiGet(`mgmt/thirdparty/biotrack/account`)
}

export const updateBiotrackAccountApi = (data) => {
  Hotjar.event('update_biotrack_account')
  return apiPut(`mgmt/thirdparty/biotrack/account`, data).then((response) =>
    console.log(response, 'updateBiotrackAccount'),
  )
}

//BIOTRACK FINISH

// UTAH ICS START

export const getUtahIcsAccountApi = () => {
  return apiGet(`mgmt/thirdparty/compliance/account`, { complianceType: 'UTAH_ICS' })
}

export const updateUtahIcsAccountApi = (data) => {
  Hotjar.event('update_utah_ics_account')
  return apiPut(`mgmt/thirdparty/compliance/account`, data)
}

export const deleteUtahIcsAccountApi = (accountId) => {
  Hotjar.event('delete_utah_ics_account')
  return apiDelete(`mgmt/thirdparty/compliance/account/${accountId}`)
}

// UTAH ICS FINISH

// metrc

export const getMetrcAPI = () => {
  return apiGet(`mgmt/thirdparty/metrc`)
}

//trackingFlag
export const getPackageTrackingLocationAPI = () => {
  return apiGet(`mgmt/thirdparty/metrc/trackingFlag`)
}

export const updateDefaultMetrcLocationAPI = (metrcLocation) => {
  Hotjar.event('update_default_metrc_location')
  return apiPost(`mgmt/thirdparty/metrc/updateMetrcLocation`, metrcLocation)
}

export const getMetrcFacilitiesAPI = () => {
  return apiGet(`mgmt/thirdparty/metrc/facilities`)
}

export const getMetrcLocationTypesAPI = () => {
  return apiGet(`mgmt/thirdparty/metrc/activeLocationTypes`)
}

export const createMetrcLocationAPI = (metrcLocation) => {
  Hotjar.event('create_metrc_location')
  return apiPost(`mgmt/thirdparty/metrc/createMetrcLocation`, metrcLocation)
}

export const getMetrcFacilitiesDataAPI = () => {
  return apiGet(`mgmt/thirdparty/metrc/facilitiesData`)
}

export const getMetrcFacilitiesDataSearchAPI = (environment, stateCode, apiKey) => {
  const params = {
    environment: environment,
    stateCode: stateCode,
    apiKey: apiKey,
  }

  return apiGet(`mgmt/thirdparty/metrc/facilities/search`, params)
}

export const updateMetrcAccountAPI = (data) => {
  Hotjar.event('update_metrc_account')
  return apiPut(`mgmt/thirdparty/metrc`, data)
}

export const addMetrcAccountAPI = (metrcAccount) => {
  Hotjar.event('add_metrc_account')
  return apiPost(`mgmt/thirdparty/addMetrc`, metrcAccount)
}

export const getMetrcEmployeeKeysAPI = (data) => {
  return apiGet(`mgmt/thirdparty/metrcEmployeeKeys`, data)
}

export const addMetrcEmployeeKeyAPI = (data) => {
  Hotjar.event('add_metrc_employee')
  return apiPost(`mgmt/thirdparty/metrcEmployeeKeys`, data)
}

export const updateMetrcEmployeeKeyAPI = (data) => {
  Hotjar.event('update_metrc_employee')
  return apiPut(`mgmt/thirdparty/metrcEmployeeKeys`, data)
}

export const deleteMetrcEmployeeKeyAPI = (id) => {
  Hotjar.event('delete_metrc_employee')
  return apiDelete(`mgmt/thirdparty/metrcEmployeeKeys/${id}`)
}

export const getLinxAccountsAPI = () => {
  return apiGet(`mgmt/thirdparty/linx`)
}

export const updateLinxAccountAPI = (data) => {
  Hotjar.event('update_linx_account')
  return apiPost(`mgmt/thirdparty/linx`, data)
}

export const getQuickBookConfigurationsAPI = () => {
  return apiGet(`quickbookservices/getConfigurations`)
}
export const getQuickBookLogsAPI = (data) => {
  return apiGet(`quickbookservices/getQuickBookSyncDetails`, data)
}

export const getQuickBookOnlineTokenInfoAPI = () => {
  return apiGet(`quickbookservices/getQuickBookOnlineAccountInfo`)
}

export const getQuickBookJobsAPI = (data) => {
  return apiGet(`quickbookservices/quickBookOnlineSyncJobDetails`, data)
}
export const getQuickBookOperationsAPI = () => {
  return apiGet(`quickbookservices/getQuickBookOperations`)
}

export const getQuickBookSyncErrorLogs = (data) => {
  return apiGet(`quickbookservices/getQuickBookErrorLogs`, data)
}

export const downloadQuickBookFileAPI = (data) => {
  Hotjar.event('download_quickbook_file')
  return apiPost(`quickbookservices/getQwcFileURL`, data)
}

export const getQuickBookTokenAPI = () => {
  return apiGet(`quickbookservices/oauth/token`)
}
export const getQuickBookRefreshTokenAPI = () => {
  return apiGet(`quickbookservices/refreshQuickBookToken`)
}
export const getQuickBookRevokeTokenAPI = () => {
  return apiGet(`quickbookservices/revokeQuickBookOnline`)
}
export const quickBookOnlineDataSyncAPI = () => {
  return apiGet(`quickbookservices/quickBookOnlineSyncEntity`)
}
export const getConnectToQuickBooksURL = () => {
  return apiGet(`quickbookservices/connectToQuickBooks`)
}

export const saveEntitiesAPI = (entity) => {
  Hotjar.event('save_quickbook_entities')
  return apiPost(`quickbookservices/quickbookCustomEntities`, entity)
}
export const saveAccountEntitiesAPI = (entity) => {
  Hotjar.event('save_quickbook_account_entities')
  return apiPost(`quickbookservices/saveQuickBookAccountDetails`, entity)
}

export const disconnectQuickbookAPI = (data) => {
  return apiGet(`quickbookservices/disconnect/quickbook`, data)
}

export const quickbookSyncEntitiesAPI = () => {
  return apiGet(`quickbookservices/syncEntity`)
}

export const getQuickbookEntityAPI = () => {
  return apiGet(`quickbookservices/getQuickbookEntity`)
}
export const updateQuickBookOperationsAPI = (data) => {
  Hotjar.event('update_quickbook_operations')
  return apiPut(`quickbookservices/updateQuickBookOperations`, data)
}
export const reSyncQuickBookOperationsAPI = (data) => {
  Hotjar.event('resync_quickbook_operations')
  return apiPost(`quickbookservices/updateSyncStatus/` + data.operationId, data)
}
export const getProductCataogiesAPI = () => {
  return apiGet(`mgmt/inventory/categories`)
}
export const getQuickBookAccountDetailsAPI = (referenceId) => {
  return apiGet(`quickbookservices/getQuickBookAccountDetails/${referenceId}`)
}
export const resetAPI = () => {
  Hotjar.event('reset_quickbook')
  return apiPost(`quickbookservices/hardResetQuickBookData/`)
}

export function thirdPartyProductsAPI(brandId, productId) {
  return apiGet(`mgmt/thirdparty/products`, { brandId, productId })
}

export function thirdPartyBrandsAPI(data) {
  return apiGet(`mgmt/thirdparty/brands`, data)
}

export function categoryMappingVersion2API(data) {
  Hotjar.event('category_mapping_version2')
  return apiPut(`mgmt/thirdparty/weedmap/category/mapping`, data)
}

// export const getProductCataogiesAPI = () => {
//     return apiGet(`mgmt/products/search`);
// }

export const getProductSearchAPI = (categoryId) => {
  return apiGet(`mgmt/products/search`, { categoryId })
}

export const getAllQuickBookAccountDetailsAPI = (data) => {
  const params = {
    start: data.start,
    limit: data.limit,
    term: data.term,
    categoryId: data.categoryId,
  }
  return apiGet(`quickbookservices/getAllQuickBookAccountDetails/${data.type}`, params)
}

export const deleteAccountEntitiesAPI = (referenceId) => {
  Hotjar.event('delete_quickbook_account_entities')
  return apiDelete(`quickbookservices/deleteQuickBookAccountDetails/${referenceId}`)
}

export const updateAccountEntitiesAPI = (entity) => {
  Hotjar.event('update_quickbook_account_entities')
  return apiPut(`quickbookservices/updateQuickBookAccountDetails/${entity.referenceId}`, entity)
}

export const updateBulkUpdatesAPI = (entity) => {
  Hotjar.event('bulkupdate_quickbook')
  return apiPut(`quickbookservices/bulkUpdateQuickBookAccountDetails`, entity)
}

// Leafly Integration

export const createLeaflyAccountAPI = (leaflyAccount) => {
  Hotjar.event('create_leafly_account')
  return apiPost(`mgmt/leafly`, leaflyAccount)
}

export const updateLeaflyAccountAPI = (leaflyAccount) => {
  Hotjar.event('update_leafly_account')
  return apiPut(`mgmt/leafly/${leaflyAccount.id}`, leaflyAccount)
}

export const getLeaflyAccountAPI = () => {
  return apiGet(`mgmt/leafly/getAccount`)
}

export const getLeaflyAccountByShopAPI = (leaflyAccountId) => {
  return apiGet(`mgmt/leafly/${leaflyAccountId}`)
}

export const getLeaflyAccountsAPI = () => {
  return apiGet(`mgmt/leafly`)
}

export const deleteLeaflyAccountAPI = (leaflyAccountId) => {
  Hotjar.event('delete_leafly_account')
  return apiDelete(`mgmt/leafly/${leaflyAccountId}`)
}

export const syncLeaflyAccountAPI = () => {
  Hotjar.event('sync_leafly_account')
  return apiPost(`mgmt/leafly/sync`)
}

export function getMenuApiProductsAPI(term, brandId, brandName, start, limit) {
  return apiGet(`mgmt/thirdparty/menuApi/products`, { term, brandId, brandName, start, limit })
}

export function getMenuApiBrandsAPI(data) {
  return apiGet(`mgmt/thirdparty/menuApi/brands`, data)
}



// WEBPACK FOOTER //
// ./src/api/thirdParty.js